import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';

import {scrolledToHonorAward} from 'shared/portfolio/actions/honor-awards';
import {MONTH_ABBRVS} from 'shared/utils';
import {HonorAward as HonorAwardType} from './honor-awards-form-wrapper';

import Text from 'shared/components/text';

interface Props {
  honorAward: HonorAwardType;
  hover?: boolean;
}

const HonorAward = ({
  honorAward: {_id, issuer, name, description, year, month, scrollTo},
  hover,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToHonorAward(_id));
      }, 550);
    }
  }, [_id, dispatch, scrollTo]);

  return (
    <div ref={ref}>
      <div className="portfolio-sections header-container larger-left-side">
        <div className="portfolio-sections card-header">
          <Text header emphasis inline weight={4} hover={hover}>
            {name}
          </Text>
        </div>
        {hover || (
          <Text inline weight={5} hover={hover} className="portfolio-sections year-ranges">
            {`${MONTH_ABBRVS[month]} ${year}`}
          </Text>
        )}
      </div>
      <Text weight={5} hover={hover}>
        {issuer}
      </Text>
      {description && (
        <Text weight={5} hover={hover} color="darkgrey">
          {description}
        </Text>
      )}
    </div>
  );
};

export default HonorAward;
